import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { CompanyProductObjectiveComponent } from 'src/app/components/main/employees/dashboard/company-product-objective/company-product-objective.component';
import { ActiveCompanyObjective } from 'src/app/models/active-company-objective.model';

@Component({
  selector: 'app-company-objective-view-dialog',
  templateUrl: './company-objective-view-dialog.component.html',
  styleUrl: './company-objective-view-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, CdkScrollable, MatButtonModule, CompanyProductObjectiveComponent],
})
export class CompanyObjectiveViewDialogComponent {
  private readonly dialog_ref = inject(MatDialogRef<CompanyObjectiveViewDialogComponent>);
  readonly data = inject<{ objective: ActiveCompanyObjective }>(MAT_DIALOG_DATA);

  close(): void {
    this.dialog_ref.close();
  }
}
